import React from 'react';
import styled from 'styled-components/native';

import Image from '@src/components/Image';
import { Body1 } from '@src/components/Typography';
import { padding } from '@src/configuration/constants';

export const TalentsBanner: React.FC = styled(Image).attrs({
  source: require('./talents.png'),
  resizeMode: 'contain',
})`
  width: 100%;
  height: 80px;
`;

export const Text = styled(Body1)`
  text-align: center;
  margin: ${padding}px 0;
`;
